import {fabric} from "fabric-with-gestures";

import EventTableHelper from "../CurrentState2/mixins/EventTableHelper";

const COLOR_BUSY_TABLE = '#e16640';
const COLOR_BUSY_CHAIR = 'rgb(179, 79, 21)';

const COLOR_NEXT_TABLE =  '#f9b03f';
const COLOR_NEXT_CHAIR = '#ff9800';
const COLOR_TXT = '#656565';


const COLOR_DEFAULT_TABLE =  '#dddddd';
const COLOR_DEFAULT_CHAIR = '#aaaaaa';


const COLOR_PREPARE_TABLE =  '#30870b';
const COLOR_PREPARE_CHAIR = '#154209b5';


export default {
  methods: {
    handleDataTables(tables){
      _.map(tables, (table) => this.handleDataTable(table))
    },

    handleDataTable(table){
      this.handleUnSelectForReservation(table);

      if(this.tableHasReservations(table)){
        this.drawInformationAboutReservations(table);
        this.canvas.renderAll();
      }else{
        this.setTableAsFree(table.canvasObject)
      }

      this.addHandleSelectForReservation(table)
    },

    addHandleSelectForReservation(table){
      EventTableHelper.addDbClickHandler(table, this.handleSelectForReservation);
    },

    addHandleUnSelectForReservation(table){
      EventTableHelper.addDbClickHandler(table, (table) => {
        this.initSelectTables.splice(this.initSelectTables.indexOf(parseInt(table.id)), 1);
        this.handleDataTable(table)
      });
    },

    handleSelectForReservation(table){
      this.setTableAsPrepareReservation(table.canvasObject);
      this.addSelectionTables(table);
      this.addHandleUnSelectForReservation(table);
    },

    handleUnSelectForReservation(table){
      this.setTableAsFree(table.canvasObject);
      this.unSelectionTable(table);
      this.addHandleSelectForReservation(table);
    },

    tableHasReservations(table){
      return table.reservations.length > 0
    },

    setTableAsPrepareReservation(object){
      this.fillColorTable(object, COLOR_PREPARE_TABLE, COLOR_PREPARE_CHAIR)
    },

    setTableAsFree(object){
      this.removeInfo(object);
      this.fillColorTable(object, COLOR_DEFAULT_TABLE, COLOR_DEFAULT_CHAIR, COLOR_TXT)
    },
    addSelectionTables(table) {
      this.selectTables.push(table.id)
    },
    unSelectionTable(table) {
      this.selectTables.splice(this.selectTables.indexOf(parseInt(table.id)), 1);
    },
    removeInfo(object){
      _.map(object.getObjects(), (o) => {
        if(o && o.hasOwnProperty('my') && o.my.type == 'info') {
          this.canvas.remove(o);
          object.remove(o)
          object.addWithUpdate();
          object.setCoords();
        }
      })
    },
    drawInformationAboutReservations(table){
      let reservations = (table.reservations);
      let offset = 0;
      this.removeInfo(table.canvasObject)
      _.map(reservations, (reservation) => {
        let time = reservation.date_time_visit.trim().split(' ')[1];
        let t = new fabric.IText((time+' '+reservation.guest.first_name).substr(0, 12), {
          fontFamily: 'Arial',
          my : {
            type : 'info'
          },
          fontWeight: 'bold',
          centeredRotation: false,
          fontSize: 16,
          fill: 'white',
          angle: table.canvasObject.angle * (-1),
          backgroundColor: '#3877ef9e',
          objectCaching: false,
          originX: 'center',
          originY : 'bottom',
          top:offset,
          left : 10
        });
        offset += t.get('height')*1.1;
        t.set({
          'left' : t.get('left') - table.canvasObject.get('width')/4,
          'top' : t.get('top') - table.canvasObject.get('height')/4
        })
        table.canvasObject.add(t)
        table.canvasObject.addWithUpdate();
        table.canvasObject.setCoords();
        this.canvas.renderAll()
      });
    },
    fillColorTable(object,colorTable, colorChair, colorTxt){
      object._objects.map(o => {
        if(!o.hasOwnProperty('my')){
          return;
        }
        if (o.my.type == 'table') {
          o.set({
            fill: colorTable
          })
        }

        let fontSize = Math.min(parseInt(object.get('height')), parseInt(object.get('width')))

        if (o.my.type == 'Text') {
          o.set({
            fill: colorTxt !== undefined ? colorTxt : 'white',
            fontFamily: 'Arial',
            originX: 'center',
            originY : 'center',
            fontSize: fontSize * this.canvas.getZoom() * 0.6
          })
        }
        if (o.my.type == 'chair') {
          o.set({
            fill: colorChair,
            stroke: colorChair,
          })
        }
      })
      this.canvas.renderAll()
    }
  }
}
